import React from "react";
import { Box, Container, Flex, Grid, GridItem } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import GitHubCalendar from "react-github-calendar";
import styled from "styled-components";

export const Statistics = () => {
  return (
    <Container
      // color="black"
      bg="black"
      border="2px solid black"
      // h="92vh"
      maxW="100%"
      id="stats"
      // display = "none"
    >
      <Text
        fontSize={{ base: "22px", lg: "40px" }}
        color="white"
        fontFamily="'Mogra', cursive"
      >
        Have a look at my Amazing GitHub Stats!
      </Text>
      <Flex
        flexDirection="column"
        // border="1px solid white"
        p={{ base: 0, lg: 0 }}
      >
        <Flex
          // border="1px solid red"
          // flex-wrap="wrap"
          justifyContent="space-around"
          // p={10}
          p={{ base: 10, lg: 10 }}
          // mt={10}
          mt={{ base: 0, lg: 10 }}
          direction={{ base: "column", lg: "row" }}
        >
          <GitImages
            id="github-stats-card"
            src="https://github-readme-stats.vercel.app/api?username=AnshKathpal&theme=react&hide_border=true&include_all_commits=false&count_private=true"
            alt=""
          />
          <GitImages
            id="github-top-langs"
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=anshkathpal&theme=react&show_icons=true&hide_border=true&layout=compact"
            alt=""
          />
          <GitImages
            id="github-streak-stats"
            src="https://github-readme-streak-stats.herokuapp.com?user=AnshKathpal&theme=react&hide_border=true"
            alt=""
          />
        </Flex>
        <Flex justifyContent="center">
          <img
            // width="80%"
            width={{ base: "100%", lg: "80%" }}
            src="https://github-readme-activity-graph.vercel.app/graph?username=anshkathpal&bg_color=000000&color=1fe5de&line=1fe5de&point=ffffff&area=true&hide_border=true)](https://github.com/ashutosh00710/github-readme-activity-graph"
            alt=""
          />
        </Flex>
      </Flex>
      <GitCalendar>
        <GitHubCalendar
          style={{ color: "white", margin: "auto", fontSize : "12"}}
          username="anshkathpal"
        />
      </GitCalendar>
    </Container>
  );
};


const GitCalendar = styled.div`

width : 80%;
margin : 20px auto;
padding : 20px;

@media screen and (max-width :480px){

  width : 100%;
  margin : 10px auto;

}


`


const GitImages = styled.img`

@media (min-width : 768px) and (max-width : 1024px){
  width : 60%;
  margin : auto;
  
}
  


`
